import React, { memo, useContext } from "react";
import { Language } from "../../App";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LuLayoutGrid,
  LuStethoscope,
  LuFileText,
  LuVideo,
  LuActivity,
  LuGraduationCap,
  LuCalendar,
} from "react-icons/lu";

/* ── Matching per-type accent config like FeedMobileFilter ── */
const TYPE_CONFIG = {
  all: {
    color: "#00BADA",
    light: "#E8FBFF",
    border: "#BCEEFA",
    shadow: "rgba(0, 186, 218, 0.22)",
  },
  doctors: {
    color: "#00BADA",
    light: "#E8FBFF",
    border: "#BCEEFA",
    shadow: "rgba(0, 186, 218, 0.22)",
  },
  posts: {
    color: "#3B82F6",
    light: "#EFF6FF",
    border: "#BFDBFE",
    shadow: "rgba(59, 130, 246, 0.22)",
  },
  webinars: {
    color: "#EF4444",
    light: "#FEF2F2",
    border: "#FECACA",
    shadow: "rgba(239, 68, 68, 0.22)",
  },
  clinicals: {
    color: "#10B981",
    light: "#ECFDF5",
    border: "#A7F3D0",
    shadow: "rgba(16, 185, 129, 0.22)",
  },
  courses: {
    color: "#8B5CF6",
    light: "#F5F3FF",
    border: "#DDD6FE",
    shadow: "rgba(139, 92, 246, 0.22)",
  },
  events: {
    color: "#F59E0B",
    light: "#FFFBEB",
    border: "#FDE68A",
    shadow: "rgba(245, 158, 11, 0.22)",
  },
};

const getConfig = (type) => TYPE_CONFIG[type] || TYPE_CONFIG.all;

function SearchFilter({ keyword, activeType }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useContext(Language);

  const pathname = location.pathname;

  const tabs = [
    {
      id: "all",
      type: "all",
      name: lang?.all || "All",
      icon: <LuLayoutGrid size={17} />,
      link: `/search?keyword=${keyword || ""}`,
      isActive: activeType ? activeType === "all" : pathname === "/search",
    },
    {
      id: "doctors",
      type: "doctors",
      name: lang?.doctors || "Doctors",
      icon: <LuStethoscope size={17} />,
      link: `/search/doctors?keyword=${keyword || ""}`,
      isActive: activeType ? activeType === "doctors" : pathname.includes("/search/doctors"),
    },
    {
      id: "posts",
      type: "posts",
      name: lang?.posts || "Posts",
      icon: <LuFileText size={17} />,
      link: `/search/posts?keyword=${keyword || ""}`,
      isActive: activeType ? activeType === "posts" : pathname.includes("/search/posts"),
    },
    {
      id: "webinars",
      type: "webinars",
      name: lang?.webinars || "Webinars",
      icon: <LuVideo size={17} />,
      link: `/search/webinars?keyword=${keyword || ""}`,
      isActive: activeType ? activeType === "webinars" : pathname.includes("/search/webinars"),
    },
    {
      id: "clinicals",
      type: "clinicals",
      name: lang?.clinical_studies || lang?.clinicals || "Clinical Studies",
      icon: <LuActivity size={17} />,
      link: `/search/clinicals?keyword=${keyword || ""}`,
      isActive: activeType ? activeType === "clinicals" : pathname.includes("/search/clinicals"),
    },
    {
      id: "courses",
      type: "courses",
      name: lang?.courses || "Courses",
      icon: <LuGraduationCap size={17} />,
      link: `/search/courses?keyword=${keyword || ""}`,
      isActive: activeType ? activeType === "courses" : pathname.includes("/search/courses"),
    },
    {
      id: "events",
      type: "events",
      name: lang?.events || "Events",
      icon: <LuCalendar size={17} />,
      link: `/search/events?keyword=${keyword || ""}`,
      isActive: activeType ? activeType === "events" : pathname.includes("/search/events"),
    },
  ];

  return (
    <div className="search-category-tabs-container">
      {tabs.map((tab) => {
        const isActive = tab.isActive;
        const cfg = getConfig(tab.type);

        return (
          <button
            key={tab.id}
            type="button"
            className={`search-cat-tab ${isActive ? "active" : ""}`}
            onClick={() => {
              if (isActive) return;
              navigate(tab.link);
            }}
            style={{
              "--tab-color": cfg.color,
              "--tab-light": cfg.light,
              "--tab-border": cfg.border,
              "--tab-shadow": cfg.shadow,
            }}
            aria-label={`Filter by ${tab.name}`}
            aria-current={isActive ? "true" : undefined}
          >
            <span className="search-cat-tab-icon">
              {tab.icon}
            </span>
            <span className="search-cat-tab-label">
              {tab.name}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default memo(SearchFilter);

